/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { FirmwareState } from './models';
import { FirmwareUpdateResult } from './models';
import { CrcCheckBody } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class FirmwareService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Firmware update data
   *
   * LWM2M path: /5//0
   *
   * @tapVersion(">=1.0")
   * @return
   */
  postPackage(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postPackageCall());
  }

  /**
   *
   *
   * LWM2M path: /5//0
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  postPackageCall(): ServiceCallType {
    const callOptions = { ...this.resources.postPackage };

    return callOptions;
  }

  /**
   * firmware Update mode
   *
   * LWM2M path: /5//2
   *
   * @tapVersion(">=1.0")
   * @return
   */
  postUpdate(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postUpdateCall());
  }

  /**
   *
   *
   * LWM2M path: /5//2
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  postUpdateCall(): ServiceCallType {
    const callOptions = { ...this.resources.postUpdate };

    return callOptions;
  }

  /**
   * Get state
   *
   * LWM2M path: /5//3
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getState(): Promise<TapResponse<FirmwareState>> {
    return this.serviceCallRunner.execute(this.getStateCall());
  }

  /**
   *
   *
   * LWM2M path: /5//3
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getStateCall(): ServiceCallType {
    const callOptions = { ...this.resources.getState };

    return callOptions;
  }

  /**
   * Get firmware update result
   *
   * LWM2M path: /5//5
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getUpdateResult(): Promise<TapResponse<FirmwareUpdateResult>> {
    return this.serviceCallRunner.execute(this.getUpdateResultCall());
  }

  /**
   *
   *
   * LWM2M path: /5//5
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getUpdateResultCall(): ServiceCallType {
    const callOptions = { ...this.resources.getUpdateResult };

    return callOptions;
  }

  /**
   * Check CRC
   *
   * LWM2M path: /5//6
   *
   * @tapVersion(">=1.0")
   * @param data input
   * @return
   */
  postCrcCheck(
    /*
     *
     */
    data: CrcCheckBody,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postCrcCheckCall(data));
  }

  /**
   *
   *
   * LWM2M path: /5//6
   *
   * @tapVersion(">=1.0")
   * @param data input
   * @return call options
   */
  postCrcCheckCall(
    /*
     *
     */
    data: CrcCheckBody,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postCrcCheck };

    callOptions.body = data;

    return callOptions;
  }
}
